import './ManageDayByDay.scss'

import * as lottie_caffe from '../../lotties/ManageDayByDay/caffe.json'
import * as lottie_package from '../../lotties/ManageDayByDay/package.json'

import AddressBookComp from '../../components/AddressBook/AddressBook'
import DidYouKnow from '../../components/DidYouKnow/DidYouKnow'
import ExternalLink from '../../components/ExternalLink/ExternalLink'
import Lottie from 'react-lottie'
import { ModalContainer } from '../../components/Containers/ModalContainer'
import { SectionContainer } from '../../components/Containers/SectionContainer'
import { animated } from 'react-spring'
import { contacts } from '../../data'

const ManageDayByDay = ({ color = 'purple', secondary = 'green', scrollRight, modalHandling, closeModal, section, parallax, setLock }) => {
  // Lotties
  const lottieCaffe = (
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData: lottie_caffe.default,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
      }}
      width={150}
      height={150}
      speed={0.5}
    />
  )
  const lottiePackage = (
    <Lottie
      options={{
        loop: true,
        autoplay: true,
        animationData: lottie_package.default,
        rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
      }}
      width={150}
      height={150}
      speed={0.5}
    />
  )

  // Modals
  const attention = (
    <ModalContainer secondary={secondary} color={color} title="Centro de atención a usuarios" onClick={() => closeModal()}>
      <p>
        Si tienes problemas con tu cuenta de correo, la conexión wifi o cualquier otro aspecto informático, puedes ponerte en contacto con el CAU, donde
        atenderán tu consulta y te indicarán cómo solucionar cualquier incidencia.
      </p>

      <DidYouKnow color={color} title={'¡Atención!'}>
        <div className="phising-upper-container">
          <p>
            Por cierto, recuerda que <span className="bold">nunca te pediremos ninguna contraseña personal por correo</span>, por lo que nunca se la des a
            nadie… ¡así evitarás ser presa de <span className="bold">phishing</span>!
          </p>
          <div className="phising-container">
            <img src="/svg/icons/phising.svg" alt="" />
          </div>
        </div>
      </DidYouKnow>
      <AddressBookComp color={color} data={contacts['cauti']} />
    </ModalContainer>
  )

  const reprography = (
    <ModalContainer secondary={secondary} color={color} title="Reprografía" onClick={() => closeModal()}>
      <p>
        El <b>Centro de Servicios Documentales</b> está ubicado en la <b>primera planta de la Plaza Mayor</b> (también puedes mandar tus documentos para
        imprimir al correo electrónico que aparece abajo) y puedes pedir que se impriman en papel reciclado. Además, en todos los centros hay máquinas en los
        pasillos para fotocopiar, escanear e imprimir.
      </p>
      <p>
        Para usarlas, <b>activa tu tarjeta</b> en el <b>centro de reprografía del campus</b>.
      </p>
      <p>
        También puedes <b>recargar el monedero</b> a través del enlace inferior, pero recuerda que para acceder debes estar en el campus con conexión a{' '}
        <i>eduroam</i> o conectarte desde fuera a través del <i>VPN UAM</i>.
      </p>
      <ExternalLink color={secondary} secondary={color} url="http://reprografia.uam.es/" text="Cargar monedero" />
      <AddressBookComp color={color} data={contacts['reprografia']} />
    </ModalContainer>
  )

  const banks = (
    <ModalContainer secondary={secondary} color={color} title="Bancos y cajeros" onClick={() => closeModal()}>
      <p>
        En campus de la UAM encontrarás diferentes cajeros del <span className="bold">Banco Santander</span> —que también tiene una sucursal en la Plaza Mayor
        UAM— y <span className="bold">Bankia</span>. Consulta el mapa para conocer su ubicación.
      </p>

      <div className="logo santander">
        <img src="/svg/logos/banco-santander.svg" alt="" />
      </div>

      <div className="logo bankia">
        <img src="/svg/logos/bankia.svg" alt="" />
      </div>
    </ModalContainer>
  )

  const mailbox = (
    <ModalContainer secondary={secondary} color={color} title="Oficina de Correos" onClick={() => closeModal()}>
      <p>
        Además de los servicios propios de una oficina de Correos, ofrece servicios bancarios y servicio de{' '}
        <span className="bold">recogida gratuita de paquetes para estudiantes alojados en la residencia Erasmo.</span>
      </p>

      <div className="logo correos">
        <img src="/svg/logos/correos.svg" alt="" />
      </div>
    </ModalContainer>
  )

  const postbox = (
    <ModalContainer secondary={secondary} color={color} title="Recogida de paquetes" onClick={() => closeModal()}>
      <div className="logo package">{lottiePackage}</div>
      <p>
        Además de la oficina de Correos, el <b>Campus de Cantoblanco</b> cuenta con <b>tres puntos de recogida/depósito de paquetería</b> (lockers) de InPost
        para que te puedas organizar según tus horarios y accesos al campus. Puedes consultar la ubicación de estos lockers en el mapa del apartado
        "Localización", dentro de la sección "CONOCE TU CENTRO DE ESTUDIOS"
      </p>
      <ExternalLink
        color={secondary}
        secondary={color}
        url="https://www.inpost.es/buscar-el-punto-pack-mas-cercano"
        text="Averigua cómo utilizar los lockers InPost"
      />
    </ModalContainer>
  )

  const coffee = (
    <ModalContainer secondary={secondary} color={color} title="Comedores y cafeterías" onClick={() => closeModal()}>
      {lottieCaffe}

      <p>
        En todas las Facultades y en la EPS existen comedores en los que puedes <span className="bold">calentar tu propia comida.</span> Además, las cafeterías
        de estos centros, la de Rectorado, el Polideportivo y la Plaza Mayor ofrecen <span className="bold">menú del día</span> y muchas otras opciones a
        precios asequibles (incluidos productos ecológicos y de comercio justo).
      </p>
      <ExternalLink color={secondary} secondary={color} url="https://www.uam.es/uam/cafeterias-y-comedores" text="Consulta los precios" />
    </ModalContainer>
  )

  const library = (
    <ModalContainer secondary={secondary} color={color} title="Librería" onClick={() => closeModal()}>
      <p>
        La UAM cuenta con una librería donde puedes adquirir <span className="bold">libros, prensa y material de papelería</span>: está situada en la planta
        baja del Edificio Plaza Mayor (tiene una sucursal más pequeña en la facultad de Medicina). En ella se aplican{' '}
        <span className="bold">descuentos especiales a los miembros de la comunidad universitaria.</span>
      </p>
      <AddressBookComp color={color} data={contacts['libreria']} />
    </ModalContainer>
  )

  const insurance = (
    <ModalContainer secondary={secondary} color={color} title="Seguro escolar" onClick={() => closeModal()}>
      <p>
        Existe un <span className="bold">seguro escolar</span> que protege a los estudiantes menores de 28 años que cursen estudios oficiales hasta el final del
        tercer ciclo universitario (doctorado) mediante prestaciones sanitarias y económicas, en caso de enfermedad, accidente escolar e infortunio familiar. El
        seguro escolar comienza a surtir efecto desde el momento en el que formalizas tu matrícula.
      </p>

      <ExternalLink color={secondary} secondary={color} url="http://www.seg-social.es/wps/portal/wss/internet/FAQ/48581/48766" text="Más info aquí" />
    </ModalContainer>
  )

  const items = [
    { key: 'attention', content: attention, title: 'Centro de atención a usuarios' },
    { key: 'reprography', content: reprography, title: 'Reprografía' },
    { key: 'banks', content: banks, title: 'Bancos y cajeros' },
    { key: 'mailbox', content: mailbox, title: 'Oficina de correos' },
    { key: 'postbox', content: postbox, title: 'Recogida de paquetes' },
    { key: 'coffee', content: coffee, title: 'Comedores y cafeterías' },
    { key: 'library', content: library, title: 'Librería' },
    { key: 'insurance', content: insurance, title: 'Seguro escolar' }
  ]

  const Splash = (
    <>
      <div className="logo-back">
        <img src="/splash/svg/ManageDayByDay_logo_back.svg" alt="" />
      </div>
      <animated.div className="logo-main" style={{ transform: parallax.logo_main(section) }}>
        <img src="/splash/svg/ManageDayByDay_logo_main.svg" className="illustration" />
        <img src="/splash/png/ManageDayByDay.png" className="image" alt="" />
      </animated.div>
      <div className="logo-front">
        <img src="/splash/svg/ManageDayByDay_logo_front.svg" alt="" />
      </div>
    </>
  )

  return (
    <SectionContainer
      // Section
      className={'ManageDayByDay'}
      title={
        <span>
          Gestiona tu <span className="nowrap">dí a</span> a <span className="nowrap">dí a</span>
        </span>
      }
      // General
      color={color}
      secondary={secondary}
      items={items}
      setLock={setLock}
      section={section}
      // Mobile
      handleMobileModal={modalHandling}
      scrollRight={scrollRight}
    >
      {Splash}
    </SectionContainer>
  )
}

export default ManageDayByDay
